import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const AuthCallback = () => {
    const navigate = useNavigate();
    const { exchangeSession } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processAuth = async () => {
            const hash = window.location.hash;
            const sessionIdMatch = hash.match(/session_id=([^&]+)/);
            
            if (sessionIdMatch) {
                const sessionId = sessionIdMatch[1];
                try {
                    const user = await exchangeSession(sessionId);
                    // Clear the hash and redirect to dashboard
                    window.history.replaceState(null, '', '/dashboard');
                    navigate('/dashboard', { state: { user }, replace: true });
                } catch (error) {
                    console.error('Auth callback failed:', error);
                    navigate('/', { replace: true });
                }
            } else {
                navigate('/', { replace: true });
            }
        };

        processAuth();
    }, [exchangeSession, navigate]);

    return (
        <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
            <div className="flex flex-col items-center gap-4">
                <Loader2 className="w-8 h-8 text-orange-500 animate-spin" />
                <p className="text-zinc-400 text-sm font-mono">Authenticating...</p>
            </div>
        </div>
    );
};
